// extracted by mini-css-extract-plugin
export default {"carouselContainer":"CountriesSlider_carouselContainer__QdXmJ","buttonContainer":"CountriesSlider_buttonContainer__wLxnj"};